import { insertSubdomain } from '@spa/shared/utils/insertSubdomain';

export const footerData = [
  {
    title: 'Uniplaces',
    items: [
      {
        id: '01',
        href: language => Buffer.from(`${process.env.APP_URL}${language}/about-us`).toString('base64'),
        translation: 'footer:About us',
        hideAnchorFromCrawlers: true
      },
      {
        id: '02',
        href: language => Buffer.from(`${process.env.APP_URL}${language}/how-it-works`).toString('base64'),
        dataEvent: 'how-it-works-click',
        translation: 'footer:How it works',
        hideAnchorFromCrawlers: true
      },
      {
        id: '03',
        href: language => `${process.env.APP_URL}${language}/partners`,
        translation: 'footer:Partners'
      },
      {
        id: '04',
        href: () => 'https://newsroom.uniplaces.com/',
        translation: 'footer:Newsroom'
      },
      {
        id: '05',
        href: () => 'https://find.uniplaces.com/guides/',
        translation: 'footer:Guides'
      }
    ]
  },
  {
    title: 'footer:Tenants',
    items: [
      {
        id: '01',
        href: language =>
          Buffer.from(mappedLinks.bookWithAnAgent[language] || mappedLinks.bookWithAnAgent.other).toString('base64'),
        translation: 'footer:Book with an agent',
        hideAnchorFromCrawlers: true
      },
      {
        id: '02',
        href: language =>
          Buffer.from(mappedLinks.inviteFriends[language] || mappedLinks.inviteFriends.en).toString('base64'),
        translation: 'footer:Invite friends',
        hideAnchorFromCrawlers: true
      },
      {
        id: '03',
        href: () => `${process.env.BLOG_URL}`,
        translation: 'footer:Stories'
      },
      {
        id: '04',
        href: () => Buffer.from(`${process.env.GROUP_BOOKING_URL}`).toString('base64'),
        translation: 'footer:Group Booking',
        hideAnchorFromCrawlers: true
      }
    ]
  },
  {
    title: 'footer:Landlords',
    items: [
      {
        id: '01',
        href: language => Buffer.from(mappedLinks.howItWorks[language] || mappedLinks.howItWorks.en).toString('base64'),
        translation: 'footer:How it works',
        hideAnchorFromCrawlers: true
      },
      {
        id: '02',
        href: language => mappedLinks.startListing[language] || mappedLinks.startListing.en,
        translation: 'footer:Start listing'
      },
      {
        id: '03',
        href: language => mappedLinks.startRent[language] || mappedLinks.startRent.en,
        translation: 'footer:List your place'
      }
    ]
  },
  {
    title: 'footer:Support',
    items: [
      {
        id: '01',
        href: language => Buffer.from(`${process.env.APP_URL}${language}/cancellation-policies`).toString('base64'),
        translation: 'footer:Cancellation policies',
        hideAnchorFromCrawlers: true
      },
      {
        id: '02',
        href: language => `${process.env.HELP_URL}?language=${language}`,
        translation: 'footer:Help'
      },
      {
        id: '03',
        href: language => Buffer.from(mappedLinks.contactUs[language] || mappedLinks.contactUs.en).toString('base64'),
        translation: 'footer:Talk to us',
        hideAnchorFromCrawlers: true
      }
    ]
  },
  {
    title: 'footer:Join us',
    items: [
      {
        id: '01',
        href: () => `${process.env.AFFILIATE_URL}`,
        translation: 'footer:Become an Affiliate'
      },
      {
        id: '02',
        href: () => `${process.env.AMBASSADOR_URL}`,
        translation: 'footer:Become an Ambassador'
      },
      {
        id: '03',
        href: () => 'https://find.uniplaces.com/b2b/',
        translation: 'footer:B2B Partnerships'
      },
      {
        id: '04',
        href: () => `${process.env.CAREERS_URL}`,
        translation: 'footer:Careers'
      }
    ]
  }
];

export const mappedLinks = {
  howItWorks: {
    en: 'https://find.uniplaces.com/howitworks/landlords/',
    de: 'https://find.uniplaces.com/de/untersttzung/vermieter/',
    es: 'https://find.uniplaces.com/es/como-funciona/propietario/',
    fr: 'https://find.uniplaces.com/fr/comment-ca-marche/propritaire/',
    it: 'https://find.uniplaces.com/it/come-funziona/proprietario/',
    pt: 'https://find.uniplaces.com/pt/como-funciona/propietario/'
  },
  startListing: {
    en: 'https://portal.uniplaces.com/english/home',
    es: 'https://portal.uniplaces.com/espanol/home',
    it: 'https://portal.uniplaces.com/italiano/home',
    pt: 'https://portal.uniplaces.com/portugues/home'
  },
  startRent: {
    en: `${insertSubdomain(`${process.env.APP_URL}`.replace('www.', ''), 'rent', 'en')}`,
    de: `${insertSubdomain(`${process.env.APP_URL}`.replace('www.', ''), 'rent', 'de')}`,
    es: `${insertSubdomain(`${process.env.APP_URL}`.replace('www.', ''), 'rent', 'es')}`,
    fr: `${insertSubdomain(`${process.env.APP_URL}`.replace('www.', ''), 'rent', 'fr')}`,
    it: `${insertSubdomain(`${process.env.APP_URL}`.replace('www.', ''), 'rent', 'it')}`,
    pt: `${insertSubdomain(`${process.env.APP_URL}`.replace('www.', ''), 'rent', 'pt')}`
  },
  inviteFriends: {
    en: 'https://find.uniplaces.com/referafriend/',
    de: 'https://find.uniplaces.com/referafriend/de/',
    es: 'https://find.uniplaces.com/referafriend/es/',
    fr: 'https://find.uniplaces.com/referafriend/fr/',
    it: 'https://find.uniplaces.com/referafriend/it/',
    pt: 'https://find.uniplaces.com/referafriend/pt/'
  },
  contactUs: {
    en: 'https://find.uniplaces.com/contactsupport/',
    pt: 'https://find.uniplaces.com/pt/apoio/',
    es: 'https://find.uniplaces.com/es/apoyo/',
    de: 'https://find.uniplaces.com/de/untersttzung/',
    fr: 'https://find.uniplaces.com/fr/soutien/',
    it: 'https://find.uniplaces.com/it/supporto/'
  },
  bookWithAnAgent: {
    en: 'https://find.uniplaces.com/talk-to-an-agent/',
    pt: 'https://find.uniplaces.com/fale-com-um-agente/pt/',
    es: 'https://find.uniplaces.com/hable-con-un-agente/es/',
    de: 'https://find.uniplaces.com/sprechen-sie-mit-einem-agenten/de/',
    fr: 'https://find.uniplaces.com/parlez-a-un-agent/fr/',
    it: 'https://find.uniplaces.com/parlare-con-un-agente/it/',
    other: 'https://find.uniplaces.com/find-accommodation-europe/'
  }
};
